import { APIResponse, Fetcher, FetchFunction } from '../core';

export type Middleware<T> = {
    process: (args: Fetcher.Args, next: FetchFunction) => Promise<APIResponse<T, Fetcher.Error>>;
};

type NextHandlerFactory = (middlewares: Middleware<any>[]) => FetchFunction;

export const createFetcherWithMiddlewares = (fetcher: FetchFunction, initialMiddlewares: Middleware<any>[]) => {
    const createNext: NextHandlerFactory = (middlewares) => (args) => {
        const [head, ...rest] = middlewares;
        return head.process(args, createNext(rest));
    };

    return createNext([
        ...initialMiddlewares,
        {
            process: (args) => fetcher(args),
        },
    ]);
};
